
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import SubjectTip from '@/components/organisms/SubjectTip.vue'
import SelectModal from '@/components/templates/SelectModal.vue'
import { SubjectCode } from '@/const/SubjectCode'

/**
 * 教科選択モーダル
 */
@Component({
  components: {
    SubjectTip,
    SelectModal,
  },
})
export default class ModalSelectSubject extends Vue {
  /** 選択用モーダル */
  @Ref()
  private selectModal!: SelectModal

  /** ボタン押下時のイベント */
  @Prop()
  private eventSubmitSubject!: (code: string) => Promise<void>

  /**
   * 教科コード一覧
   *
   * @returns 教科コードのリスト
   */
  private get subjectCodeList(): string[] {
    return SubjectCode.LIST.map((subject) => subject.code)
  }

  /**
   * ボタン押下時のイベント
   */
  private async submitSubject(): Promise<void> {
    this.selectModal.hide()
    await this.eventSubmitSubject(this.selectModal.currentItemCode)
  }

  /**
   * モーダルを開く
   *
   * @param currentSubjectCode 現在の教科コード
   */
  public show(currentSubjectCode: string): void {
    this.selectModal.show(currentSubjectCode)
  }
}
